/* eslint-disable no-unused-vars */
export enum INTERACTION_PARAMS {
  COMPONENT_ERRORS = 'component_errors',
}

export type InteractionParams = {
  [INTERACTION_PARAMS.COMPONENT_ERRORS]: string[];
};

export type JobParams = {
  start_date: string;
  end_date: string;
};

export type Params = JobParams & InteractionParams;
export type DraftParams = Partial<Params>;
